import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_s, mobile_xl, mobile_xs } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter } from '../../../global/commonStyle';

const Group = styled.div`
  width: 100%;
  max-width: 662px;
  margin: var(--space-0) auto;
  .loading-animation {
    overflow: hidden;
  }
  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }
  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;
const Header = styled.div`
  ${FlexBetween}
  padding-block: var(--space-20) var(--space-12);
  width: 100%;
  max-width: 662px;
  margin: var(--space-0) auto;
`;
const PersonalText = styled.div`
  ${Typography.heading_lg}
  color: var(--text-primary);
`;
const Total = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: var(--space-16);
  ${mobile_xl(css`
    grid-template-columns: repeat(2, 1fr);
  `)}
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  ${mobile_xl(css`
    gap: var(--space-24);
    margin-block: var(--space-8) var(--space-80);
  `)}
`;

const Storage = styled.div`
  width: 100%;
  max-width: 622px;
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  padding: var(--space-20);
  background-color: var(--background-primary);
  box-shadow: var(--shadow-card);
  ${AlignCenter}
  gap: var(--space-24);
  ${mobile_xl(css`
    width: auto;
  `)}
`;
const Left = styled.div`
  width: 136px;
  height: 136px;
  position: relative;
  ${FlexCenter}
  .circle {
    width: 136px;
    height: 136px;
    border-radius: var(--border-radius-full);
    position: relative;
    background-color: var(--background-muted);
    ${mobile_xl(css`
      width: 100px;
      height: 100px;
    `)}
  }
  .segment {
    position: absolute;
    width: 100px;
    height: 100px;
    border-radius: var(--border-radius-full);
    clip: rect(0px, 100px, 45px, 0px);
    background-color: var(--background-muted);
  }
  .segment1 {
    transform: rotate(125deg);
  }
  .inner-circle {
    width: 76px;
    height: 76px;
    background-color: var(--background-primary);
    border-radius: var(--border-radius-full);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: var(--z-index-base);
  }
  ${mobile_xl(css`
    width: 100px;
    height: 100px;
  `)}
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
`;
const Title = styled.div`
  width: 136px;
  height: 9px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  ${mobile_xl(css`
    width: 126px;
  `)}
  ${mobile_s(css`
    width: 90px;
  `)}
 ${mobile_xs(css`
    width: 60px;
  `)}
`;
const Description = styled.div`
  width: 290px;
  height: 9px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  ${mobile_xl(css`
    width: 161px;
  `)}
  ${mobile_s(css`
    width: 121px;
  `)}
  ${mobile_xs(css`
    width: 86px;
  `)}
`;
const TeamMember = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--space-16) var(--space-11);
  gap: var(--space-10);
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
  ${mobile_xl(css`
    &:first-child {
      grid-area: 1 / span 2;
    }
  `)}
`;
const Top = styled.div`
  ${FlexBetween}
  width: 186px;
  height: 16px;
  ${mobile_xl(css`
    width: 100%;
    gap: var(--space-10);
  `)}
`;

const TopTitle = styled.div`
  width: 135px;
  height: 9px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  ${mobile_xl(css`
    max-width: 122px;
    width: 100%;
  `)}
`;
const Bottom = styled.div`
  width: 50px;
  height: 9px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
`;
const CheckBox = styled.div`
  width: 16px;
  height: 16px;
  border-radius: var(--border-radius-4);
  background-color: var(--background-muted);
`;
export {
  Group,
  Header,
  PersonalText,
  Total,
  Storage,
  Content,
  Left,
  Right,
  Title,
  Description,
  TeamMember,
  Top,
  TopTitle,
  CheckBox,
  Bottom
};
